import * as types from '../types'
// state
const state = {
  activeTime: 'hour'
}

const mutations = {
  [types.ACTIVETIME](state, activeTime) {
    state.activeTime = activeTime
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/switcher.js